import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from '../../../services/user.service';
import { AnalyticsEvent } from '../../charts/realtime-feed/realtime-feed.component';

@Component({
  selector: 'app-event-feed-details-dialog',
  templateUrl: './event-feed-details-dialog.component.html',
  styleUrl: './event-feed-details-dialog.component.scss',
})
export class EventFeedDetailsDialogComponent {
  @Input() item: AnalyticsEvent;

  constructor(
    protected dialogRef: NbDialogRef<EventFeedDetailsDialogComponent>,
    protected userService: UserService
  ) {}

  getAvatarUrl(id: string): string {
    return this.userService.getAvatar(id);
  }
}
